import React, { FC, useRef, useState } from "react";
import html2canvas from "html2canvas";
import GMap from "../../../components/GoogleMap/index";
import api from "../../../api";
import { MediaFile } from "../../../core";
import { toastr } from "react-redux-toastr";

interface CaptureGoogleMapViewProps {
  canDownload?: boolean;
  fileName?: string;
  apiKey: string;
  locations: { lat: number; lng: number; name: string }[];
  height?: string;
  width?: string;
  loading?: boolean;
  onContinue: (image?: MediaFile) => void;
}

const CaptureGoogleMapView: FC<CaptureGoogleMapViewProps> = (props) => {
  const mapRef = useRef<HTMLDivElement | null>(null);
  const [capturedImage, setCapturedImage] = useState<string | null>(null);

  const [imageCapturing, setImageCapturing] = useState(false);
  const [imageCaptured, setImageCaptued] = useState<MediaFile>();

  const exportAsImage = async (element: any, imageFileName: string) => {
    const canvas = document.createElement("canvas");
    canvas.width = element.clientWidth;
    canvas.height = element.clientHeight;

    const canvasScreenshot = await html2canvas(element, {
      canvas,
      useCORS: true,
      allowTaint: true,
    });
    const image = canvasScreenshot.toDataURL("image/png", 1.0);

    const imageUploaded = await api.upload.uploadBase64File(image);
    setCapturedImage(image);
    setImageCaptued(imageUploaded);
    setImageCapturing(false);
    toastr.success("Success", "Location successfully captured ");
  };

  return (
    <div className="pt-4">
      <div className="w-100 bg-gray-100 mt-3" style={{ height: "592px" }}>
        <GMap
          locations={props?.locations || []}
          loading={props?.loading || false}
          apiKey={props?.apiKey || ""}
          mapRef={mapRef}
          height={props?.height || "592px"}
          width={props?.width || null}
        />
      </div>

      <div className="mt-4 mb-1 d-flex justify-content-end">
        <button
          type="button"
          className="btn bg-primary select-prop-bt font-normal font-weight-bold text-white mr-3"
          disabled={props?.locations?.length === 0 || imageCapturing}
          onClick={() => {
            setImageCapturing(true);
            setTimeout(() => {
              exportAsImage(mapRef.current, props?.fileName || "googlemap");
            }, 1000);
          }}
        >
          {capturedImage ? "Capture Again" : "Capture"}
        </button>
        <button
          type="button"
          className="btn bg-primary select-prop-bt font-normal font-weight-bold text-white"
          disabled={!imageCaptured}
          onClick={() => props.onContinue(imageCaptured)}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default CaptureGoogleMapView;
